module.exports = __webpack_public_path__ + "static/media/digitales-02.82616cc3.png";